import React from 'react'

const NUB_OVERSIZE_PIXELS = 3

export default function MenuNub ({
  nubSize,
  nubRatio,
  position
}) {
  const height = nubSize + NUB_OVERSIZE_PIXELS
  const width = nubSize * nubRatio

  // Create SVG paths
  const nubPrimaryPath = [
    { x: 0, y: nubSize },
    { x: nubSize * (nubRatio / 2), y: 0 },
    { x: nubSize * nubRatio, y: nubSize }
  ]
  const nubBorderKillerPath = [
    { x: -NUB_OVERSIZE_PIXELS, y: nubSize + NUB_OVERSIZE_PIXELS },
    { x: nubSize * (nubRatio / 2), y: NUB_OVERSIZE_PIXELS / 2 },
    { x: (nubSize * nubRatio) + NUB_OVERSIZE_PIXELS, y: nubSize + NUB_OVERSIZE_PIXELS }
  ]

  // Create style
  const _style = {
    position: 'absolute'
  }
  
  if (position.isLeft) {
    // Undo nub offset and the center on nub = 1.5 multiplier
    _style.left = `${nubSize}px`
  }
  if (position.isRight) {
    _style.right = `${nubSize * 1.5}px`
  }
  if (position.isTop) {
    _style.top = `-${height - NUB_OVERSIZE_PIXELS}px`
  }
  if (position.isBottom) {
    _style.transform = `rotate(180deg)`,
    _style.bottom = `-${height - NUB_OVERSIZE_PIXELS}px`
  }

  return (
    <svg className="menu-nubbin" height={height} width={width} style={_style}>
      <path
        d={`M ${nubPrimaryPath.map(p => `${p.x},${p.y}`).join(' ')}`}
      />
      <path
        d={`M ${nubBorderKillerPath.map(p => `${p.x},${p.y}`).join(' ')}`}
        style={{strokeWidth: 0 }}
      />
    </svg>
  )
}